module.exports = __webpack_public_path__ + "img/logo.6950ad94.svg";